import { useNavigate } from 'react-router-dom';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, Spinner } from 'reactstrap';
import useDeleteQuote from '../../hooks/useDeleteQuote';

// Same shape as viewCustomerPage's delete modal. The backend returns 422 for
// a converted quote — that surfaces via the hook's onError toast, so the
// modal itself doesn't need to pre-check convertedToJobId (we also disable
// the triggering button on the page when locked).
export default function DeleteQuoteModal({ isOpen, onClose, quote }) {
    const navigate = useNavigate();
    const deleteQuote = useDeleteQuote();

    const handleDelete = () => {
        if (!quote?.id) return;
        deleteQuote.mutate(quote.id, {
            onSuccess: () => {
                onClose();
                navigate('/quotes');
            },
        });
    };

    return (
        <Modal isOpen={isOpen}
               toggle={() => !deleteQuote.isPending && onClose()}
               centered backdrop="static">
            <ModalHeader toggle={() => !deleteQuote.isPending && onClose()}>
                Delete quote?
            </ModalHeader>
            <ModalBody>
                <p className="mb-2">
                    Permanently delete <strong>{quote?.quoteNumber ?? 'this quote'}</strong>?
                </p>
                <p className="text-muted mb-0 small">
                    This also deletes every line item on the quote. This cannot be undone.
                </p>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" outline onClick={onClose}
                        disabled={deleteQuote.isPending}>
                    Cancel
                </Button>
                <Button color="danger" onClick={handleDelete}
                        disabled={deleteQuote.isPending}>
                    {deleteQuote.isPending && <Spinner size="sm" className="me-1" />}
                    Delete
                </Button>
            </ModalFooter>
        </Modal>
    );
}
